import { create } from 'zustand';
import type { PanelRoute } from '@app/routes/types';

interface LayoutState {
  activePanel: PanelRoute | null;
  panelPinned: boolean;
  setActivePanel: (panel: PanelRoute | null) => void;
  togglePanelPin: () => void;
}

export const useLayoutStore = create<LayoutState>((set) => ({
  activePanel: null,
  panelPinned: true,
  setActivePanel: (panel) => set({ activePanel: panel }),
  togglePanelPin: () => set((state) => ({ panelPinned: !state.panelPinned })),
}));
